import { render, staticRenderFns } from "./LightboxBiographyCard.vue?vue&type=template&id=deb6ca40"
import script from "./LightboxBiographyCard.vue?vue&type=script&lang=js"
export * from "./LightboxBiographyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports